import '@cnx-saas/common-fe/polyfills';
import React from 'react';
import { render } from 'react-dom';
import * as Sentry from '@sentry/react';
import { LicenseInfo } from '@mui/x-data-grid-pro';
import { App } from './components';

Sentry.init({
  enabled: process.env.NODE_ENV === 'production',
  environment: process.env.APP_ENV,
  dsn: process.env.SENTRY_DSN,
});

LicenseInfo.setLicenseKey(
  '8a4637bca05baba984180b1925a20dffTz0xMTMzNTMsRT0xNzc5NDk0Mzk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=',
);
render(<App />, document.getElementById('root'));
